import { Box, Button, Grid } from "@mui/material";
import logo from "../images/logo.png";
import loginBackground from "../images/loginBackground.png";
import LanguageIcon from "@mui/icons-material/Language";

import useLoginContainer from "../containers/useLoginContainer";
import LoginForm from "../components/Login/LoginForm";
import ResetEmailForm from "../components/Login/ResetEmailForm";
import OtpForm from "../components/Login/OtpForm";
import NewPasswordForm from "../components/Login/NewPasswordForm";
import { Colors } from "../theme/colors";
import AlertMessage from "../components/AlertMessage";
import { useAlert } from "../context/AlertContext";
import { LanguagesApp } from "../hooks/useLanguage/languagesApp";
import { useLanguage } from "../hooks/useLanguage";
import { useContent } from "../content/useContent";

const classes = {
  middle: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: Colors.primary,
    textAlign: "center",
  },
  logo: {
    width: "65.52px",
    height: "127.53px",
  },
  bigLogo: {
    width: "156.48px",
    height: "304.58px",
  },
  minWidth: {
    minWidth: 300,
    width: "60%",
    display: "flex",
    "flex-direction": "column",
    alignItems: "center",
  },
  title: {
    margin: "30px 0 0",
    textAlign: "center",
  },
  background: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `linear-gradient(145.47deg, rgba(16, 40, 66,0.8) 0%, rgba(0, 167, 160,0.8) 100%),url(${loginBackground})`,
    display: { md: "flex", xs: "none" },
    justifyContent: "center",
    alignItems: "center",
  },
};

const Login = () => {
  const {
    formikLogin,
    formikResetEmail,
    loading,
    otpUser,
    showResetEmail,
    setShowResetEmail,
    showOtp,
    setShowOtp,
    formikOtp,
    formikPassword,
    handleShowLogin,
    count,
  } = useLoginContainer();
  const { value, msg, setValue, error } = useAlert();
  const { setLanguage, language } = useLanguage();
  const { nav } = useContent();

  const handleLanguage = () => {
    if (language === LanguagesApp.Arabic) {
      setLanguage(LanguagesApp.English);
    } else {
      setLanguage(LanguagesApp.Arabic);
    }
  };

  return (
    <>
      <Grid container>
        <Grid item md={6} xs={12} sx={classes.middle}>
          <Box sx={classes.minWidth}>
            <img src={logo} alt="logo" style={classes.logo} />

            <Box component="form" noValidate sx={{ width: "100%" }}>
              {showResetEmail && (
                <ResetEmailForm
                  formik={formikResetEmail}
                  loading={loading}
                  setShowResetEmail={setShowResetEmail}
                />
              )}
              {showOtp && (
                <OtpForm
                  handleResentOtp={formikResetEmail.handleSubmit}
                  formik={formikOtp}
                  loading={loading}
                  setShowResetEmail={setShowResetEmail}
                  setShowOtp={setShowOtp}
                  count={count}
                />
              )}

              {otpUser && (
                <NewPasswordForm
                  formik={formikPassword}
                  loading={loading}
                  handleShowLogin={handleShowLogin}
                />
              )}
              {!otpUser && !showResetEmail && !showOtp && (
                <LoginForm
                  formik={formikLogin}
                  loading={loading}
                  setShowResetEmail={setShowResetEmail}
                />
              )}
            </Box>
            <Button
              variant="outlined"
              startIcon={<LanguageIcon />}
              onClick={handleLanguage}
              sx={{ mt: 2 }}
              color="secondary"
            >
              {nav.language}
            </Button>
          </Box>
        </Grid>
        <Grid item md={6} sx={classes.background}>
          <img src={logo} alt="logo" style={classes.bigLogo} />
        </Grid>
      </Grid>
      <AlertMessage value={value} setValue={setValue} error={error} msg={msg} />
    </>
  );
};
export default Login;
